import { InstanceScreen } from 'component/navigation/instance';
import { useLocalSearchParams } from 'expo-router';

export default function SpaceComposerScreen() {
    const { commentKey1, preselectedPerspectiveText1, sliderValue1, voteKey1, voteLabel1 } =
        useLocalSearchParams<'/[siloKey]/question/[instanceKey]/composer'>();
    return (
        <InstanceScreen params={{ commentKey1, preselectedPerspectiveText1, sliderValue1, voteKey1, voteLabel1 }} screenKey='composer' />
    );
}
